import { useRef, useState } from 'react';
import { LogOut, UserRound } from 'lucide-react';
import { useAuth } from '../auth/context';
import { ROLE_LABELS } from '../config/roles';
import { useClickOutside } from '../lib/useClickOutside';

export function UserMenu() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(ref, open, () => setOpen(false));
  if (!user) return null;
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        className="icon-btn"
        aria-label={`Account: ${user.name}`}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <UserRound size={18} />
      </button>
      {open && (
        <div className="popover" role="menu" style={{ top: 38, right: 0 }}>
          <div className="menu-head" style={{ color: 'var(--label)', fontSize: 13 }}>
            {user.name}
          </div>
          <div className="menu-head" style={{ fontWeight: 400 }}>
            {user.email}
          </div>
          <div className="menu-head" style={{ fontWeight: 400 }}>
            {ROLE_LABELS[user.role]}
          </div>
          <div className="menu-sep" />
          <button type="button" role="menuitem" className="menu-item" onClick={() => void logout()}>
            <LogOut size={15} /> Sign out
          </button>
        </div>
      )}
    </div>
  );
}
